import { createContext, useContext, useState } from "react";

const NavbarContext = createContext(null);
export const NavBarProvider = ({ children }) => {
  const [logoPosition, setLogoPosition] = useState(null);
  const [togglePosition, setTogglePosition] = useState(null);
  const [navigate, setNavigate] = useState(-1);
  
  const setLogoPlace = (text) => {
    setLogoPosition(text);
  };
  const setTogglePlace = (toggle) => {
    setTogglePosition(toggle);
  };

  const setToPrevPage = (number) => {
    setNavigate(-number);
  }

  const reset = () => {
    setLogoPosition(null);
    setTogglePosition(null);
  };

  return (
    <NavbarContext.Provider value={{ logoPosition, togglePosition, navigate, setLogoPlace, setTogglePlace, setToPrevPage, reset }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => {
  return useContext(NavbarContext);
};
